var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScanner = function SvgScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 54.352 54.295"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6 0H11.631A8.763 8.763 0 0 0 2.88 8.751v12.673a1.382 1.382 0 0 0 2.763 0V8.751a5.994 5.994 0 0 1 5.987-5.987h33.968a6 6 0 0 1 5.99 5.987V39.92a6 6 0 0 1-5.99 5.99H33.541a1.382 1.382 0 1 0 0 2.763h12.057a8.766 8.766 0 0 0 8.754-8.754V8.751a8.766 8.766 0 0 0-8.754-8.752Z",
    "data-name": "Path 12172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.151 41.874-1.315 3.367a6.649 6.649 0 0 0 4.012 8.684 6.87 6.87 0 0 0 2.176.369 6.664 6.664 0 0 0 6.164-4.2l.973-2.46h2.326a5.074 5.074 0 0 0 4.626-3l.923-2.028h2.32a3.977 3.977 0 0 0 3.657-2.407l4.2-9.766a3.568 3.568 0 0 0-3.274-4.975H8.574A8.575 8.575 0 0 0 5.15 41.894Zm8.478 7.205a3.872 3.872 0 0 1-7.208-2.827l1.448-3.72c.24.02.471.071.712.071h7.6Zm7.973-5.574a2.314 2.314 0 0 1-2.1 1.363h-1.234l.9-2.267h2.839ZM8.584 28.212h23.349a.8.8 0 0 1 .739 1.118l-4.2 9.766a1.212 1.212 0 0 1-1.12.735H8.577a5.815 5.815 0 1 1 0-11.63Z",
    "data-name": "Path 12173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.468 18.5v-7.818a1.382 1.382 0 0 0-2.763 0V18.5a1.382 1.382 0 0 0 2.763 0Z",
    "data-name": "Path 12174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.384 18.5v-7.818a1.382 1.382 0 1 0-2.763 0V18.5a1.382 1.382 0 1 0 2.763 0Z",
    "data-name": "Path 12175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.297 18.5v-7.818a1.382 1.382 0 0 0-2.763 0V18.5a1.382 1.382 0 0 0 2.763 0Z",
    "data-name": "Path 12176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.18 28.537a1.381 1.381 0 0 0 1.382-1.382V10.683a1.382 1.382 0 0 0-2.763 0v16.472a1.377 1.377 0 0 0 1.382 1.382Z",
    "data-name": "Path 12177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.797 33.724a1.382 1.382 0 1 0 2.763 0V31.91a1.382 1.382 0 0 0-2.763 0Z",
    "data-name": "Path 12178"
  }))));
};
export default SvgScanner;